import * as React from 'react';

import { cn } from '@/utils/cn';

interface PageContentProps extends React.HTMLAttributes<HTMLDivElement> {
    scroll?: 'self' | 'children';
    padding?: 'default' | 'none';
    topPadding?: 'default' | 'none';
}

export const PageContent = React.forwardRef<HTMLDivElement, PageContentProps>(
    ({ className, scroll = 'self', padding = 'default', topPadding = 'default', ...props }, ref) => (
        <div
            ref={ref}
            className={cn(
                'min-h-0 flex-1',
                scroll === 'children' ? 'flex flex-col overflow-hidden' : 'overflow-auto',
                padding === 'default' && 'px-6 pb-6',
                padding === 'default' && topPadding === 'default' && 'pt-2',
                className,
            )}
            {...props}
        />
    ),
);
PageContent.displayName = 'PageContent';
